module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8503/img/design-manager.svg"